import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        outline: none;
        border: none;
        box-sizing: border-box;
        font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    }

    :root {
        --color-primary: #ec6625;
        --color-secondary: #ff8601;
        --color-tertiary: #f31d2f;
        --color-quaternary: #03a2fd;
        --color-quinary: #27ae60;

        --nooio-gradient: var(--color-primary), var(--color-tertiary), var(--color-secondary), var(--color-quaternary), var(--color-quinary);
        
        --color-error: #ff0033;
        --color-success: #4BB543;
        --color-warning: #FFAD32;

        --color-title: #000;
        --color-text: #414143;

        --color-background: #fff;
    }

    .content {
        width: 1120px;
        margin: 0 auto;
    }

    html {
        font-size: 10px;
    }

    body.active {
        overflow: hidden;
    }

    html, body, #root {
        position: relative;
        min-height: 100vh;
        color: var(--color-text);
        background: var(--color-background);
        -webkit-font-smoothing: antialiased;
    }

    h1, h2, h3, h4 {
        color: var(--color-title);
        font-family: 'Ubuntu', Helvetica, Arial, sans-serif;
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    button {
        cursor: pointer;
    }

    .shadow {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        background: rgba(0, 0, 0, .5);
    }


    @media (max-width: 1280px) {
        html {
            font-size: 9px;
        }

        .content {
            width: 80%;
        }
    }

    @media (max-width: 1024px) {
        html {
            font-size: 8px;
        }
    }

    @media (max-width: 768px) {
        html {
            font-size: 7px;
        }

        .content {
            width: 90%;
        }
    }

    @media (max-width: 425px) {
        html {
            font-size: 6px;
        }
    }
`;

export default GlobalStyle;